module.exports = __webpack_public_path__ + "img/guide-cod-1.1acfe611.png";